import { CSSObject } from '@mantine/core'
import { MantineThemeComponents } from '@mantine/styles/lib/theme/types/MantineTheme'
import { getSelectStyles } from 'plugin-mantine-resources/src/helpers/SelectHelpers'

export const Select: MantineThemeComponents['Select'] = {
    styles: (__, _, runtimeProps): Record<string, CSSObject> => {
        return getSelectStyles(runtimeProps)
    }
}
